import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Message } from '../_models/message';
import { environment } from '../../../environments/environment';

@Injectable()
export class MessageService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  // Ottieni tutti i messaggi
  getMessages(): Observable<Message[]> {
    return this.http.get<Message[]>(`${this.apiBaseUrl}api/private/v1/comunication/messages`);
  }

  // Ottieni un singolo messaggio per id
  getMessage(id: number): Observable<Message> {
    return this.http.get<Message>(`${this.apiBaseUrl}api/private/v1/comunication/messages/${id}`);
  }

  // Salva un nuovo messaggio
  saveMessage(messageItem: Message): Observable<Message> {
    const message = { ...messageItem };
    delete message.lastUpdated;
    delete message.dateCreated;

    let companyIdsExtra = '';
    if (message.recipientType === 'farm' && message.recipientId) {
      companyIdsExtra = `?companyIds=${message.recipientId}`;
    }

    if (message.id) {
      // Implementa la logica per modificare un messaggio esistente se necessario
      return this.http.put<Message>(
        `${this.apiBaseUrl}api/private/v1/comunication/messages/${message.id}`,
        message
      );
    } else {
      return this.http.post<Message>(
        `${this.apiBaseUrl}api/private/v1/comunication/messages${companyIdsExtra}`,
        message
      );
    }
  }

  deleteMessage(id: number): Observable<Message> {
    return this.http.delete(this.apiBaseUrl + 'apiapi/private/v1/comunication/messages/' + id).pipe(
      map((response) => {
        return { id } as Message;
      })
    );
  }
}
